import axios from '@/utils/axios'

export const getReceive = (payload) => {
    return axios.get('/receive', {
        params: payload
    })
}

export const createReceive = (data) => {
    return axios.post('/receive', data)
}

export const updateReceive = (id, data) => {
    return axios.put(`/receive/${id}`, data)
}

export const getReceiveById = (id) => {
    return axios.get(`/receive/${id}`)
}

export const deleteReceive = (id) => {
    return axios.delete(`/receive/${id}`)
}

export const invalidReceive = (id, data) => {
    return axios.put(`/invalid_receive/${id}`, data)
}

export const getReceiveStat = (payload) => {
    return axios.get('/receive_stat', {
        params: payload
    })
}

export const getCustomerDefaultReceiveInfo = (id, data) => {
    return axios.get(`/cus_default_receive_info/${id}`, data)
}